export default "__VITE_ASSET__DlsqqAv2__"